import TemplateView from "../../TemplateView";
import SimpleListMenuButton from "../../SimpleListMenuButton";
import GroupType from "../../enums/GroupType";
import messageResource from "../../messageResource";

export default class GroupBySelector extends TemplateView {
    constructor({onGroupBySelected = groupBy => {}}) {
        super();

        this.onGroupBySelected = onGroupBySelected;

        this.state = {
            groupBy: GroupType.USER_GROUP
        };

        this.onStatePropertyChanged("groupBy", groupBy => this._updateMenuButton(groupBy))
    }

    templateHtml() {
        return "<div class='groupBySelector'></div>"
    }

    afterRender() {
        this.menuButton = new SimpleListMenuButton({
            itemHtmlCallback: groupType => {
                if (groupType === GroupType.USER_GROUP)
                    return messageResource.getEscapedMessage("common.User_Group");
                else if (groupType === GroupType.TIME_ZONE_GROUP)
                    return messageResource.getEscapedMessage("common.Time_Zone_Group");
            },
            onSelect: groupType => {
                this.setState({groupBy: groupType});
                this.onGroupBySelected(groupType);
            },
            extraClass: "withLinkStyle",
            menuExtraClass: "groupBySelectorMenu",
            menuPositionParams: {
                my: "right top",
                at: "right bottom",
            },
            autoMenuWidth: false
        }).init(this.$el);

        this.renderInitialState();
    }

    _updateMenuButton(groupBy) {
        this.menuButton.setItems([GroupType.USER_GROUP, GroupType.TIME_ZONE_GROUP], groupBy);
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/usersAssignedToHierarchy/GroupBySelector.js